import { method } from "lodash";
import { api } from './baseApiSetup.js';
import { json } from "d3";
import GetProxy from '../GetProxy.js';

const proxy = GetProxy()
const GNC_BASE_API = `${proxy}/api/v1`;

export const GNCapi = api.injectEndpoints({
  endpoints: (build) => ({
    //Gnc Home
    getProjectCreation: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/gnc/projectCreation`,
        method: "POST",
        body: postBody,
      }),
    }),
    getLoginTrend: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/activeUserCount`,
        method: "POST",
        body: postBody,
      }),
    }),
    getCountWidgets: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/gnc/countWidgets`,
        method: "POST",
        body: postBody,
      }),
    }),

    getActiveUsersAllTools: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/currentDayLoggedUserStatus`,
        method: "POST",
        body: postBody,
      }),
    }),

    getActiveUsersLast: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/getCountofActiveUsers`,
        method: "POST",
        body: postBody,
      }),
    }),

    getjiraLoggedUserData: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraLoggedUserData`,
        method: "POST",
        body: postBody,
      }),
    }),
    getconfluenceLoggedUserData: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluenceLoggedUserData`,
        method: "POST",
        body: postBody,
      }),
    }),
    getjenkinsLoggedUserData: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jenkinsLoggedUserData`,
        method: "POST",
        body: postBody,
      }),
    }),
    getbitBucketLoggedUserData: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/bitBucketLoggedUserData`,
        method: "POST",
        body: postBody,
      }),
    }),

    getjiraActiveUserData: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/currentDayJiraLoggedUserDetails`,
        method: "POST",
        body: postBody,
      }),
    }),
    getconfluenceActiveUserData: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/currentDayConfluenceLoggedUserDetails`,
        method: "POST",
        body: postBody,
      }),
    }),
    getjenkinsActiveUserData: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/currentDayJenkinsLoggedUserDetails`,
        method: "POST",
        body: postBody,
      }),
    }),
    getbitbucketActiveUserData: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/currentDayBitbucketLoggedUserDetails`,
        method: "POST",
        body: postBody,
      }),
    }),
    getOSData: build.mutation({
      query: () => ({
        url: `${GNC_BASE_API}/licenceConfigForServerRest/listForGraph`,
        method: "GET",
      }),
    }),

    getcurrentDayLoggedUserStatus: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/currentDayLoggedUserStatus`,
        method: "POST",
        body: postBody,
      }),
    }),
    getlicenseCountJira: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/licenseCountJira`,
        method: "POST",
        body: postBody,
      }),
    }),
    getlicenseCountJenkins: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/licenseCountJenkins`,
        method: "POST",
        body: postBody,
      }),
    }),
    getlicenseCountConfluence: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/licenseCountConfluence`,
        method: "POST",
        body: postBody,
      }),
    }),
    getlicenseCountBitbucket: build.mutation({
      query: () => ({
        url: `${GNC_BASE_API}/g&c/toolsInfoBitbucket/bitbucket`,
        method: "GET",
      }),
    }),
    getlicenseUserAlret: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/email/sent/alert`,
        method: "POST",
        body: postBody,
      }),
    }),

    getlicenseUserAutoAlret: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/autoMailAlert`,
        method: "POST",
        body: postBody,
      }),
    }),
    getlicenseUserInactiveDays: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/autoauth`,
        method: "POST",
        body: postBody,
      }),
    }),
    getlicenseUserCancelAlret: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/email/cancel/autoalert`,
        method: "POST",
        body: postBody,
      }),
    }),
    getdetails: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/autoauthdetails`,
        method: "POST",
        body: postBody,
      }),
    }),
    // Pii

    getPiibitbucketRepo: build.query({
      query: ({ projectName }) => ({
        url: `${GNC_BASE_API}/bitbucketPII/bitbucketProjectName/${projectName}`,
        method: "GET",
      }),
    }),
    getPiibitbucketProjectList: build.mutation({
      query: () => ({
        url: `${GNC_BASE_API}/bitbucketPII/bitbucketProjectList`,
        method: "GET",
      }),
    }),

    getPiiconfluenceSpaceList: build.mutation({
      query: () => ({
        url: `${GNC_BASE_API}/confluencePII/confluenceSpaceList`,
        method: "GET",
      }),
    }),

    getbitBucketPIIBasedOnFile: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/bitbucketPII/bitBucketPIIBasedOnFile`,
        method: "POST",
        body: postBody,
      }),
    }),
    getbitBucketPIIBasedOnPiiType: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/bitbucketPII/bitBucketPIIBasedOnPiiType`,
        method: "POST",
        body: postBody,
      }),
    }),
    getbitBucketPIIBasedOnUserName: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/bitbucketPII/bitBucketPIIBasedOnUserName`,
        method: "POST",
        body: postBody,
      }),
    }),
    getbitBucketPIIReport: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/bitbucketPII/bitBucketPIIReport`,
        method: "POST",
        body: postBody,
      }),
    }),

    getconfluencePIIBasedOnContentType: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluencePIIBasedOnPIIcontentType`,
        method: "POST",
        body: postBody,
      }),
    }),
    getconfluencePIIBasedOnPIIType: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluencePIIBasedOnPIIType`,
        method: "POST",
        body: postBody,
      }),
    }),
    getconfluencePIIBasedOnPageAuthor: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluencePIIBasedOnPageAuthor`,
        method: "POST",
        body: postBody,
      }),
    }),
    getconfluencePIIReport: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluencePIIReport`,
        method: "POST",
        body: postBody,
      }),
    }),
    //Admin Activity
    getAdminActConf: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/AdminActConfluence`,
        method: "POST",
        body: postBody,
      }),
    }),

    getAdminActJira: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/AdminActJira`,
        method: "POST",
        body: postBody,
      }),
    }),

    getAdminActJenkins: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/AdminActJenkins`,
        method: "POST",
        body: postBody,
      }),
    }),

    getAdminActBitBucket: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/adminActBitbucket`,
        method: "POST",
        body: postBody,
      }),
    }),

    getAdminActJenkinsTable: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jenkinsAdminData`,
        method: "POST",
        body: postBody,
      }),
    }),

    getAdminActJiraTable: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraAdminData`,
        method: "POST",
        body: postBody,
      }),
    }),

    getAdminActbitBucketTable: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/bitBucketAdminData`,
        method: "POST",
        body: postBody,
      }),
    }),

    getAdminActconfluenceTable: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/ConfluenceEvent`,
        method: "POST",
        body: postBody,
      }),
    }),

    //admin Graph API
    getAdminActconfluenceGraph: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluenceMonthTrendData`,
        method: "POST",
        body: postBody,
      }),
    }),

    getAdminActbitbucketGraph: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/bitbucketMonthTrendData`,
        method: "POST",
        body: postBody,
      }),
    }),

    getAdminActjenkinsGraph: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jenkinsMonthTrendData`,
        method: "POST",
        body: postBody,
      }),
    }),

    getAdminActjiraGraph: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraMonthTrendData`,
        method: "POST",
        body: postBody,
      }),
    }),
    //Jira Table API
    getjiraAdminLoginLogout: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraAdminLoginLogout`,
        method: "POST",
        body: postBody,
      }),
    }),

    getjiraAdminProjectCreatedDelected: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraAdminProjectCreatedDelected`,
        method: "POST",
        body: postBody,
      }),
    }),

    getjiraAdminUserAdded: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraAdminUserAdded`,
        method: "POST",
        body: postBody,
      }),
    }),

    getjiraAdminUserRemoved: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraAdminUserRemoved`,
        method: "POST",
        body: postBody,
      }),
    }),

    getjiraAdminActivityOthers: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraAdminActivityOthers`,
        method: "POST",
        body: postBody,
      }),
    }),

    getjiraAdminUserUpdated: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraAdminUserUpdated`,
        method: "POST",
        body: postBody,
      }),
    }),

    getjiraAdminUserCreated: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraAdminUserCreated`,
        method: "POST",
        body: postBody,
      }),
    }),

    getjiraAdminUserDeleted: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/jiraAdminUserDeleted`,
        method: "POST",
        body: postBody,
      }),
    }),




    //Confluence API 

    getconfluenceAdminLoginLogout: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluenceAdminLoginLogout`,
        method: "POST",
        body: postBody,
      }),
    }),

    getConfluenceAdminCreatedRemoved: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/ConfluenceAdminCreatedRemoved`,
        method: "POST",
        body: postBody,
      }),
    }),

    // getConfluenceAdminCreatedRemoved: build.mutation({
    //   query: (postBody = {}) => ({
    //     url: `${GNC_BASE_API}/g&c/ConfluenceAdminCreatedRemoved`,
    //     method: "POST",
    //     body: postBody,
    //   }),
    // }),

    getconfluenceAdminUserAddedRemoved: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluenceAdminUserAddedRemoved`,
        method: "POST",
        body: postBody,
      }),
    }),

    getconfluenceAdminUpdated: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluenceAdminUpdated`,
        method: "POST",
        body: postBody,
      }),
    }),
    //others of Confluence
    getconfluenceAdminOthersForDeleted: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluenceAdminOthersForDeleted`,
        method: "POST",
        body: postBody,
      }),
    }),

    getconfluenceAdminOthersForDeletedGroup: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluenceAdminOthersForDeletedGroup`,
        method: "POST",
        body: postBody,
      }),
    }),

    getconfluenceAdminOthersUpdated: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluenceAdminOthersUpdated`,
        method: "POST",
        body: postBody,
      }),
    }),

    getconfluenceAdminUserCreatedGroup: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluenceAdminUserCreatedGroup`,
        method: "POST",
        body: postBody,
      }),
    }),

    getconfluenceAdminUserCreatedPage: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/g&c/confluenceAdminUserCreatedPage`,
        method: "POST",
        body: postBody,
      }),
    }),
    //  Vulnerability
    getTopVulnerability: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/list/topVulnerability`,
        method: "POST",
        body: postBody,
      }),
    }),
    getTotalVulnerability: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/list/totalVulnerability`,
        method: "POST",
        body: postBody,
      }),
    }),
    getUnplannedVulnerabilities: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/getOpenCountByCriticalityFiltered`,
        method: "POST",
        body: postBody,
      }),
    }),
    getTargetDateDue: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/getSixMonthTargetDate`,
        method: "POST",
        body: postBody,
      }),
    }),
    getTablePopup: build.mutation({
      query: ({ id }) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/commentDescription/list/${id}`,
        method: "GET",
      }),
    }),
    getTargetMissedItems: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/getTargetDates`,
        method: "POST",
        body: postBody,
      }),
    }),
    getUnplannedPerAccountId: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/CISO/list/countOpenVulnerabilities`,
        method: "POST",
        body: postBody,
      }),
    }),
    getUnplannedPerApplication: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/CISO/getCountByOpen`,
        method: "POST",
        body: postBody,
      }),
    }),
    getScoreCardVulnerability: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/list/categorizeVulnerability`,
        method: "POST",
        body: postBody,
      }),
    }),

    // getCisoVmTableList: build.mutation({
    //   query: ({ payload,pageNumber,itemsPerPage, isRedirectedFromMail, refId }) => {
    //     let url = isRedirectedFromMail ? `${GNC_BASE_API}/tenableNessusRest/clickHereListForSearchWithPagination/${refId}/${pageNumber}/${itemsPerPage}` : `${GNC_BASE_API}/tenableNessusRest/getVulnerabilityListForCISOBySearchAndPagination/${pageNumber}/${itemsPerPage}`
    //     return {
    //     url,
    //     method: "POST",
    //     body: payload,
    //     }
    //   },
    // }),
    // getCisoVmTableListCount: build.mutation({
    //   query: ({tablePayload, isRedirected, refId}) => {
    //     let url = isRedirected ? `${GNC_BASE_API}/tenableNessusRest/clickHereListForSearchWithPaginationCount/${refId}` : `${GNC_BASE_API}/tenableNessusRest/getVulnerabilityListCountForCISO`;
    //     return {
    //     url,
    //     method: "POST",
    //     body: tablePayload || {},
    //     }
    //   },
    // }),
    getCisoMailRequest: build.mutation({
      query: ({ userName, mailPayload }) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/cisoApproveOrRejectMail`,
        method: "POST",
        body: mailPayload,
      }),
    }),

    getCisoApproveOrReject: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/list/approvedRejectedData`,
        method: "POST",
        body: postBody,
      }),
    }),
    // getVulnerabilityManagementList: build.mutation({
    //   query: () => ({
    //     url: `${GNC_BASE_API}/tenableNessusRest/list`,
    //     method: "GET",
    //   }),
    // }),
    getVulnerabilityRequest: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/vulnerability/request`,
        method: "POST",
        body: postBody,
      }),
    }),

    getUnplannedVulnerability: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/open/count`,
        method: "POST",
        body: postBody,
      }),
    }),

    getSendMailResponseRequest: build.mutation({
      query: ({ userName, mailPayload }) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/cisoRequestMail/${userName}`,
        method: "POST",
        body: mailPayload,
      }),
    }),

    getVulnerabilityDrill: build.mutation({
      query: ({ scanId, pluginId, ip }) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/list/pluginIdDetails/${scanId}/${pluginId}/${ip}`,
        method: "POST",
      }),
    }),
    getCVSSv2Data: build.mutation({
      query: ({ pluginId, ip, scanId }) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/getTenableCvssVersion2VectorDetails/${pluginId}/${ip}/${scanId}`,
        method: "GET",
      }),
    }),
    getCVSSv3Data: build.mutation({
      query: ({ pluginId, ip, scanId }) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/getTenableCvssVersion3VectorDetails/${pluginId}/${ip}/${scanId}`,
        method: "GET",
      }),
    }),
    getCisoDetails: build.mutation({
      query: () => ({
        url: `${GNC_BASE_API}/tenableNessusRest/listByCiso/`,
        method: "GET",
      }),
    }),

    getCategorizeVulnerabilityByStatus: build.mutation({
      query: ({ payload }) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/CISO/list/categorizeVulnerabilityByStatus`,
        method: "POST",
        body: payload,
      }),
    }),

    //TRMG
    getMainTableCompliance: build.mutation({
      query: ({ payload, packName, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/conformancePack/TRMG/List/${packName}/${pageNumber}/${itemsPerPage}`,
        method: "POST",
        body: payload,
      }),
    }),
    getMainTableComplianceCount: build.mutation({
      query: ({ payload, packName }) => ({
        url: `${GNC_BASE_API}/conformancePack/countTrmgListData/${packName}`,
        method: "POST",
        body: payload,
      }),
    }),

    //RMIT
    getRmitMainTableCompliance: build.mutation({
      query: ({ payload, packName, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/awsRMITConfigController/getTableListData/${packName}/${pageNumber}/${itemsPerPage}`,
        method: "POST",
        body: payload,
      }),
    }),
    getRmitMainTableComplianceCount: build.mutation({
      query: ({ payload, packName }) => ({
        url: `${GNC_BASE_API}/awsRMITConfigController/getTableListCount/${packName}`,
        method: "POST",
        body: payload,
      }),
    }),

    getMainChartCompliance: build.mutation({
      query: ({ payload, packName }) => ({
        url: `${GNC_BASE_API}/conformancePack/TRMG/GraphData/${packName}`,
        method: "POST",
        body: payload,
      }),
    }),

    //rmit
    getRmitMainChartCompliance: build.mutation({
      query: ({ payload, packName }) => ({
        url: `${GNC_BASE_API}/conformancePack/TRMG/GraphData/${packName}`,
        method: "POST",
        body: payload,
      }),
    }),
    getNonComplianceDrilldown: build.mutation({
      query: ({ accountId, packName, payload, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/conformancePack/TRMG/getSearchNonCompliancesRules/list/${packName}/${accountId}/${pageNumber}/${itemsPerPage}`,
        method: "POST",
        body: payload,
      }),
    }),
    getNonComplianceDrilldownCount: build.mutation({
      query: ({ accountId, packName, payload }) => ({
        url: `${GNC_BASE_API}/conformancePack/TRMG/getCountForNonCompliance/${packName}/${accountId}`,
        method: "POST",
        body: payload,
      }),
    }),
    getComplianceDrilldown: build.mutation({
      query: ({ accountId, packName, payload, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/conformancePack/TRMG/getSearchCompliancesRules/list/${packName}/${accountId}/${pageNumber}/${itemsPerPage}`,
        method: "POST",
        body: payload,
      }),
    }),
    getComplianceDrilldownCount: build.mutation({
      query: ({ accountId, packName, payload }) => ({
        url: `${GNC_BASE_API}/conformancePack/TRMG/getCountForTrmgCompliance/${packName}/${accountId}`,
        method: "POST",
        body: payload,
      }),
    }),
    getNotApplicableDrilldown: build.mutation({
      query: ({ accountId, packName, payload, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/conformancePack/TRMG/GetNotApplicable/list/${packName}/${accountId}/${pageNumber}/${itemsPerPage}`,
        method: "POST",
        body: payload,
      }),
    }),
    getNotApplicableDrilldownCount: build.mutation({
      query: ({ accountId, packName, payload }) => ({
        url: `${GNC_BASE_API}/conformancePack/TRMG/getCountForNotApplicable/${packName}/${accountId}`,
        method: "POST",
        body: payload,
      }),
    }),
    getRulesDrilldown: build.mutation({
      query: ({ configRuleName, accountName, packName, compliantType, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/conformancePack/getResourceDataAndDescriptionsPagination/${configRuleName}/${accountName}/${packName}/${compliantType}/none/none/${pageNumber}/${itemsPerPage}`,
        method: "GET",
      }),
    }),
    getRulesDrilldownTrmg: build.mutation({
      query: ({ configRuleName, accountName, packName, compliantType, pageNumber, itemsPerPage, sortByColumn, sortingOrder }) => ({
        url: `${GNC_BASE_API}/conformancePack/getResourceDataAndDescriptionsPagination/${configRuleName}/${accountName}/${packName}/${compliantType}/${sortByColumn}/${sortingOrder}/${pageNumber}/${itemsPerPage}`,
        method: "GET",
      }),
    }),
    getRmitRulesDrilldown: build.mutation({
      query: ({ configRuleName, accountName, packName, compliantType, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/conformancePack/getResourceDataAndDescriptionsPagination/${configRuleName}/${accountName}/${packName}/${compliantType}/none/none/${pageNumber}/${itemsPerPage}`,
        method: "GET",
      }),
    }),
    getRmitRulesDrilldownTrmg: build.mutation({
      query: ({ configRuleName, accountName, packName, compliantType, pageNumber, itemsPerPage, sortByColumn, sortingOrder }) => ({
        url: `${GNC_BASE_API}/awsRMITConfigController/getResourceDataAndDescriptionsPagination/${configRuleName}/${accountName}/${compliantType}/${pageNumber}/${itemsPerPage}`,
        method: "GET",
      }),
    }),
    getRulesDrilldownCount: build.mutation({
      query: ({ accountName, packName, userName }) => ({
        url: `${GNC_BASE_API}/conformancePack/count/${packName}/${accountName}/${userName}`,
        method: "GET",
      }),
    }),
    getRequestDrilldown: build.mutation({
      query: ({ payload, configRuleName }) => ({
        url: `${GNC_BASE_API}/conformancePack/conformanceRequest/${configRuleName}`,
        method: "POST",
        body: payload,
      }),
    }),
    getRequestDrilldownOnPremise: build.mutation({
      query: ({ payload, configRuleName }) => ({
        url: `${GNC_BASE_API}/CircularNineOnPremisesController/circularNineRequest`,
        method: "POST",
        body: payload,
      }),
    }),
    getDetailsconformancePackOnPremise: build.mutation({
      query: ({ configId }) => ({
        url: `${GNC_BASE_API}/CircularNineOnPremisesController/getCircularNineOnPremiseCommentList/${configId}`,
        method: "GET",
      }),
    }),
    getRmitRequestDrilldown: build.mutation({
      query: ({ payload, configRuleName }) => ({
        url: `${GNC_BASE_API}/awsRMITConfigController/manageComplianceForRMIT`,
        method: "POST",
        body: payload,
      }),
    }),
    getRequesttrmgMail: build.mutation({
      query: ({ mailPayload, configRuleName, userName }) => ({
        url: `${GNC_BASE_API}/conformancePack/cisoRequestMail/${userName}/${configRuleName}`,
        method: "POST",
        body: mailPayload,
      }),
    }),
    getDetailsconformancePack: build.mutation({
      query: ({ configId }) => ({
        url: `${GNC_BASE_API}/conformancePack/commentDescription/list/${configId}`,
        method: "GET",
      }),
    }),
    getRmitDetailsconformancePack: build.mutation({
      query: ({ configId }) => ({
        url: `${GNC_BASE_API}/awsRMITConfigController/commentDescription/list/${configId}`,
        method: "GET",
      }),
    }),
    getUserAccessReviewTotalCount: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/UserAccessRest/userAccessReviewTotalCount`,
        method: "POST",
        body: postBody,
      }),
    }),
    getUserAccessReviewPendingList: build.mutation({
      query: ({ postBody, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/awsIam/getAwsDetailsWithPaginationAndSearch/${pageNumber}/${itemsPerPage}`,
        method: "POST",
        body: postBody,
      }),
    }),
    getUserAccessReviewPendingListCount: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/awsIam/getAwsDetailsWithSearchCount`,
        method: "POST",
        body: postBody,
      }),
    }),


    //complance security hub findiings
    getSecurityHubList: build.mutation({
      query: ({ payload, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/aws/getSecurityHubListBySearchWithStatus/list/${pageNumber}/${itemsPerPage}`,
        method: "POST",
        body: payload,
      }),
    }),
    getSecurityHubListCount: build.mutation({
      query: ({ payload, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/aws/getSecurityHubListBySearchBasedOnCount`,
        method: "POST",
        body: payload,
      }),
    }),
    getSecurityHubFilter: build.mutation({
      query: () => ({
        url: `${GNC_BASE_API}/aws/filter`,
        method: "GET",
      }),
    }),
    //ICM private
    getIcmTableData: build.mutation({
      query: ({ payload, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/LDAPDashboard/LDAPDashboardDataWithSearchAndPagination/${pageNumber}/${itemsPerPage}`,
        method: "POST",
        body: payload,
      }),
    }),
    getIcmPrivateTableDataCount: build.mutation({
      query: ({ payload, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/LDAPDashboard/getCountForLDAPUsers`,
        method: "POST",
        body: payload,
      }),
    }),
    //ICM Public

    getIcmTableDataPublic: build.mutation({
      query: ({ postBody, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/AWSIAMConfigRest/getAllAWSClouds/${pageNumber}/${itemsPerPage}`,
        method: "POST",
        body: postBody,
      }),
    }),
    getIcmTableDataPublicCount: build.mutation({
      query: (postBody) => ({
        url: `${GNC_BASE_API}/AWSIAMConfigRest/getCountForAWSClouds`,
        method: "POST",
        body: postBody,
      }),
    }),
    getIcmDashboardPublicCount: build.mutation({
      query: (postBody) => ({
        url: `${GNC_BASE_API}/AWSIAMConfigRest/AWSIAMConfigDataUserCount`,
        method: "POST",
        body: postBody,
      }),
    }),
    getPasswordChangeComplianceTrendCloud: build.mutation({
      query: (postBody) => ({
        url: `${GNC_BASE_API}/AWSIAMConfigRest/PasswordChangedDataGraph`,
        method: "POST",
        body: postBody,
      }),
    }),
    getPasswordChangeDueCloud: build.mutation({
      query: (postBody) => ({
        url: `${GNC_BASE_API}/AWSIAMConfigRest/PasswordDueDataGraph`,
        method: "POST",
        body: postBody,
      }),
    }),

    getSeverityFindings: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/aws/getSeverityCount`,
        method: "POST",
        body: postBody,
      }),
    }),
    getNonCompliancePerAccountID: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/aws/getFailedCount`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFilteredAccountId: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/CSPForAws/accountIds`,
        method: "POST",
        body: postBody,
      }),
    }),
    getNumberOfCompliance: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/aws/complianceGraph/list`,
        method: "POST",
        body: postBody,
      }),
    }),
    getAwsRequest: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/aws/awsRequest`,
        method: "POST",
        body: postBody,
      }),
    }),
    getAwsMailRequest: build.mutation({
      query: ({ userName, mailPayload }) => ({
        url: `${GNC_BASE_API}/aws/cisoRequestMail/${userName}`,
        method: "POST",
        body: mailPayload,
      }),
    }),
    getIcmTotalCount: build.mutation({
      query: (postBody) => ({
        url: `${GNC_BASE_API}/LDAPDashboard/LDAPUserCount`,
        method: "POST",
        body: postBody,
      }),
    }),
    getIcmPasswordChangedDueData: build.mutation({
      query: (postBody) => ({
        url: `${GNC_BASE_API}/LDAPDashboard/PasswordChangedDueData`,
        method: "POST",
        body: postBody,
      }),
    }),
    getIcmPasswordChangedData: build.mutation({
      query: (postBody) => ({
        url: `${GNC_BASE_API}/LDAPDashboard/PasswordChangedData`,
        method: "POST",
        body: postBody,
      }),
    }),
    getCisoListShub: build.mutation({
      query: ({ payload, pageNumber, itemsPerPage, isRedirectedFromMail, refId }) => {
        let url = isRedirectedFromMail ? `${GNC_BASE_API}/aws/clickHereAWSListForSearchWithPagination/${refId}/${pageNumber}/${itemsPerPage}` : `${GNC_BASE_API}/aws/awsListForCISOWithSearch/${pageNumber}/${itemsPerPage}`
        return {
          url,
          method: "POST",
          body: payload,
        }
      },
    }),
    getCisoListShubCount: build.mutation({
      query: ({ tablePayload, isRedirected, refId }) => {
        let url = isRedirected ? `${GNC_BASE_API}/aws/clickHereAWSListCount/${refId}` : `${GNC_BASE_API}/aws/awsListForCISOWithSearchCount`
        return {
          url,
          method: "POST",
          body: tablePayload || {},
        }
      },
    }),
    getCisoApproveSecurity: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/aws/list/approvedRejectedData`,
        method: "POST",
        body: postBody,
      }),
    }),
    getTrmgListCiso: build.mutation({
      query: ({ packName, payload, pageNumber, itemsPerPage, isRedirectedFromMail, refId }) => {
        let url = isRedirectedFromMail ? `${GNC_BASE_API}/conformancePack/getCISOListByRefId/${packName}/${refId}/${pageNumber}/${itemsPerPage}` : `${GNC_BASE_API}/conformancePack/ListWithSearchAndPagination/${packName}/${pageNumber ?? 0}/${itemsPerPage ?? 10}`
        return {
          url,
          method: "POST",
          body: payload,
        }
      },
    }),
    getTrmgCircularCount: build.mutation({
      query: ({ packName, payload, isRedirected, refId }) => {
        let url = isRedirected ? `${GNC_BASE_API}/conformancePack/getCISOListCountByRefId/${packName}/${refId}` : `${GNC_BASE_API}/conformancePack/conformanceListForCISOWithSearchCount/${packName}`
        return {
          url,
          method: "POST",
          body: payload,
        }
      },
    }),
    getCisoApproveTrmg: build.mutation({
      query: ({ packName, payload }) => ({
        url: `${GNC_BASE_API}/conformancePack/TRMG/list/approvedRejectedData/${packName}`,
        method: "POST",
        body: payload,
      }),
    }),

    getCisoApproveRMiT: build.mutation({
      query: ({ packName, payload }) => ({
        url: `${GNC_BASE_API}/awsRMITConfigController/list/approvedRejectedData`,
        method: "POST",
        body: payload,
      }),
    }),

    getCisoTrmgMail: build.mutation({
      query: ({ packName, mailPayload }) => ({
        url: `${GNC_BASE_API}/conformancePack/cisoApproveOrRejectMail/trmg`,
        method: "POST",
        body: mailPayload,
      }),
    }),

    getCisoCircularMail: build.mutation({
      query: ({ packName, mailPayload }) => ({
        url: `${GNC_BASE_API}/conformancePack/cisoApproveOrRejectMail/Circular-09`,
        method: "POST",
        body: mailPayload,
      }),
    }),

    getCisoSecurityMail: build.mutation({
      query: ({ mailPayload }) => ({
        url: `${GNC_BASE_API}/aws/cisoApproveOrRejectMail`,
        method: "POST",
        body: mailPayload,
      }),
    }),

    getNonComplianceByApplication: build.mutation({
      query: ({ payload }) => ({
        url: `${GNC_BASE_API}/aws/getNonCompliantCountByApplication`,
        method: "POST",
        body: payload,
      }),
    }),

    getNonCompliantCountByCriticality: build.mutation({
      query: ({ payload }) => ({
        url: `${GNC_BASE_API}/aws/getNonCompliantCountByCriticality`,
        method: "POST",
        body: payload,
      }),
    }),
    getSixMonthTargetDate: build.mutation({
      query: ({ payload }) => ({
        url: `${GNC_BASE_API}/aws/getSixMonthTargetDate`,
        method: "POST",
        body: payload,
      }),
    }),
    getNonCompliantByResourceWiseCount: build.mutation({
      query: ({ payload }) => ({
        url: `${GNC_BASE_API}/aws/getNonCompliantByResourceWiseCount`,
        method: "POST",
        body: payload,
      }),
    }),
    getComplianceType: build.mutation({
      query: ({ payload }) => ({
        url: `${GNC_BASE_API}/aws/getComplianceStatusCount`,
        method: "POST",
        body: payload,
      }),
    }),
    getTargetDates: build.mutation({
      query: ({ payload }) => ({
        url: `${GNC_BASE_API}/aws/getTargetDates`,
        method: "POST",
        body: payload,
      }),
    }),
    //Ciso dashboard
    getCountByStatusForVul: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/CISO/getCountByStatusForVul`,
        method: "POST",
        body: postBody,
      }),
    }),
    getapplicationForVul: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/ciscoGraph/application`,
        method: "POST",
        body: postBody,
      }),
    }),
    getActionPlanForVul: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/ActionPlanCountsForVM`,
        method: "POST",
        body: postBody,
      }),
    }),
    getapplicationForhub: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/aws/appCodeCountForCISO`,
        method: "POST",
        body: postBody,
      }),
    }),
    getActionPlanForhub: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/aws/actionPlanCounts`,
        method: "POST",
        body: postBody,
      }),
    }),
    getActionPlanForhubCiso: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/aws/actionPlanCountsForCiso`,
        method: "POST",
        body: postBody,
      }),
    }),
    getCountByStatusForhub: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/aws/CISO/getCountByStatus`,
        method: "POST",
        body: postBody,
      }),
    }),

    getVmDescriptionCiso: build.mutation({
      query: ({ tenableId }) => ({
        url: `${GNC_BASE_API}/tenableNessusRest/commentDescription/list/${tenableId}`,
        method: "GET",
      })
    }),
    getShfDescriptionCiso: build.mutation({
      query: ({ AwsSecurityHubId }) => ({
        url: `${GNC_BASE_API}/AwsCommentList/list/${AwsSecurityHubId}`,
        method: "GET",
      })
    }),
    getTrmgDescriptionCiso: build.mutation({
      query: ({ configId }) => ({
        url: `${GNC_BASE_API}/conformancePack/commentDescription/list/${configId}`,
        method: "GET",
      })
    }),
    getRMiTDescriptionCiso: build.mutation({
      query: ({ configId }) => ({
        url: `${GNC_BASE_API}/awsRMITConfigController/commentDescription/list/${configId}`,
        method: "GET",
      })
    }),

    getCountByStatusFortrmg: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/conformancePack/CISO/getCountByStatusForTRMG`,
        method: "POST",
        body: postBody,
      }),
    }),
    getapplicationFortrmg: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/conformancePack/CISO/AppCodeWiseCountForTRMG`,
        method: "POST",
        body: postBody,
      }),
    }),
    getActionPlanFortrmg: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/conformancePack/CISO/actionPlanCountForTRMG`,
        method: "POST",
        body: postBody,
      }),
    }),

    getCountByStatusForc9: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/conformancePack/CISO/getCountByStatusForCircularR09`,
        method: "POST",
        body: postBody,
      }),
    }),
    getapplicationForc9: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/conformancePack/CISO/AppCodeWiseCountForCircularR09`,
        method: "POST",
        body: postBody,
      }),
    }),
    getActionPlanForc9: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/conformancePack/CISO/actionPlanCountForCircularR09`,
        method: "POST",
        body: postBody,
      }),
    }),
    getResourceforSecurityHub: build.mutation({
      query: ({ id }) => ({
        url: `${GNC_BASE_API}/aws/getResourceAndTitle/${id}`,
        method: "GET",
      })
    }),
    getAwsCommentList: build.mutation({
      query: ({ id: id }) => ({
        url: `${GNC_BASE_API}/AwsCommentList/list/${id}`,
        method: "GET",
      })
    }),
    getAwsApprovedRejectedData: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/aws/list/approvedRejectedData`,
        method: "POST",
        body: postBody,
      })
    }),

    //CIS Benchmark Compliance
    // getCisBenchmarkList: build.mutation({
    //   query: ({payload, pageNumber, itemsPerPage}) => ({
    //     url: `${GNC_BASE_API}/tenableNessusComplianceRest/list/cisBenchMark/${pageNumber}/${itemsPerPage}`,
    //     method: "POST",
    //     body: payload,
    //   }),
    // }),
    // getCisBenchmarkListCount: build.mutation({
    //   query: ({payload}) => ({
    //     url: `${GNC_BASE_API}/tenableNessusComplianceRest/cisBenchMarkListPaginationCount`,
    //     method: "POST",
    //     body: payload,
    //   }),
    // }),
    getCisAppCriticality: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/CisComplianceByCriticality`,
        method: "POST",
        body: payload,
      }),
    }),
    getCisBenchmarkRequest: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/CISRequestAPI`,
        method: "POST",
        body: postBody,
      }),
    }),

    getCisBenchmarkMailRequest: build.mutation({
      query: ({ userName, mailPayload }) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/cisRequestMail/${userName}`,
        method: "POST",
        body: mailPayload,
      }),
    }),
    //CIS Benchmark CISO
    getCisBenchmarkTableData: build.mutation({
      query: ({ payload, pageNumber, itemsPerPage, isRedirectedFromMail, refId }) => {
        let url = isRedirectedFromMail ? `${GNC_BASE_API}/tenableNessusComplianceRest/getCISOListByReqId/${refId}/${pageNumber}/${itemsPerPage}` : `${GNC_BASE_API}/tenableNessusComplianceRest/listForCISBenchMarkSearch/${pageNumber}/${itemsPerPage}`
        return {
          url,
          method: "POST",
          body: payload,
        }
      },
    }),
    getCisBenchmarkTableDataCount: build.mutation({
      query: ({ payload, isRedirected, refId }) => {
        let url = isRedirected ? `${GNC_BASE_API}/tenableNessusComplianceRest/getCISOListCountByReqId/${refId}` : `${GNC_BASE_API}/tenableNessusComplianceRest/cisBenchMarkListPaginationCountForCISO`;
        return {
          url,
          method: "POST",
          body: payload,
        }
      },
    }),
    getCisBenchmarkActionPlan: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/CISO/CisComplianceByActionPlan`,
        method: "POST",
        body: postBody,
      }),
    }),
    // getCisBenchmarkStatusCount: build.mutation({
    //   query: (postBody = {}) => ({
    //     url: `${GNC_BASE_API}/tenableNessusComplianceRest/CISO/getCountByStatusForCisBenchMark`,
    //     method: "POST",
    //     body: postBody,
    //   }),
    // }),
    // getCisBenchmarkByApp: build.mutation({
    //   query: (postBody = {}) => ({
    //     url: `${GNC_BASE_API}/tenableNessusComplianceRest/ciscoGraph/application`,
    //     method: "POST",
    //     body: postBody,
    //   }),
    // }),
    getCisoApproveCis: build.mutation({
      query: (postBody = {}) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/CISApprovedRejectedAPI`,
        method: "POST",
        body: postBody,
      }),
    }),
    getUnplannedTrendCIS: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/unplanned/count`,
        method: "POST",
        body: payload,
      }),
    }),
    getActionPlanCIS: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/CisBenchmarkActionPlanCounts`,
        method: "POST",
        body: payload,
      }),
    }),
    getPerApplicationCIS: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/CisBenchmarkPerApplication`,
        method: "POST",
        body: payload,
      }),
    }),
    getSeverityLevelsCIS: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/getServerityLevels`,
        method: "POST",
        body: payload,
      }),
    }),
    getTargetDueDateTrendCIS: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/cis/getSixMonthTargetDate`,
        method: "POST",
        body: payload,
      }),
    }),

    getCisTargetDateDue: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/getTargetDates`,
        method: "POST",
        body: payload,
      }),
    }),
    getCISTablePopup: build.mutation({
      query: ({ id }) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/commentDescription/list/${id}`,
        method: "GET",
      }),
    }),
    getCISPluginDetails: build.mutation({
      query: ({ scanId, pluginId, ip }) => ({
        url: `${GNC_BASE_API}/tenableNessusComplianceRest/list/pluginIdDetails/${scanId}/${pluginId}/${ip}`,
        method: "POST",
      }),
    }),

    //Complinace assessment

    getListForComplianceAssessment: build.mutation({
      query: (request) => ({
        url: `${GNC_BASE_API}/complianceAssessment/ComplianceAssessmentForApplication/${request.page}/${request.pageLimit}`,
        method: "POST",
        body: { "keyword": request.keyword,
                "userName" : request.userName },
      }),
    }),

    getCountForComplianceAssessmentData: build.mutation({
      query: (keyword) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getAssessmentComplianceCount`,
        method: "POST",
        body: { "keyword": keyword }
      })
    }),

    getPolicyNameList: build.mutation({
      query: () => ({
        url: `${GNC_BASE_API}/RiskAssessmentResponse/getPolicyNameList`,
        method: "GET",
      }),
    }),
    getPolicyTSQCount: build.mutation({
      query: (id) => ({
        url: `${GNC_BASE_API}/RiskAssessmentResponse/list/riskAssessmentPolicies/${id}`,
        method: "GET",
      }),
    }),
    getSaveAPICommplianceAssessment: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/RiskAssessmentResponse/save&update`,
        method: "POST",
        body: payload,
      }),
    }),
    getTopicHeaders: build.mutation({
      query: ({ assessmentId }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getComplianceAssessmentDetails`,
        method: "POST",
        body: {
          complianceAssessment: assessmentId,
        }
      }),
    }),
    getTopicsListCount: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getComplianceAssessmentPolicyListWithPaginationAndSearchForCount`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          keyword: initialData.keyword
        }
      })
    }),
    getTopicNameList: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getComplianceAssessmentPolicyListWithPaginationAndSearch/${initialData.page}/${initialData.pageLimit}`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          keyword: initialData.keyword
        }
      }),
    }),
    getSubtopicsHeader: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getMainAssessmentQuestionWithTopicAndCompliantItem`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          topicName: initialData.topicName
        }
      })
    }),
    getSubTopicsListCount: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getComplianceAssessmentSubTopicListWithPaginationAndSearchForCount`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          topicName: initialData.topicName,
          keyword: initialData.keyword
        }
      }),
    }),
    getSubTopicNameList: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getComplianceAssessmentSubTopicListWithPaginationAndSearch/${initialData.page}/${initialData.pageLimit}`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          topicName: initialData.topicName,
          keyword: initialData.keyword
        }
      }),
    }),
    getQuestionsHeader: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getMainAssessmentQuestionWithSubTopicAndCompliantItem`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          topicName: initialData.topicName,
          subTopicName: initialData.subTopicName,
          clauseNo: initialData?.clauseNo,
          clauseName: initialData?.clauseName
        }
      })
    }),
    getClauseHeader: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getMainClauseWithPolicyAndTopicAndSubtopicCompliantItem`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          topicName: initialData.topicName,
          subTopicName: initialData.subTopicName
        }
      })
    }),

    getQuestionCount: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getComplianceAssessmentQuestionListWithPaginationAndSearchForCount`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          topicName: initialData.topicName,
          subTopicName: initialData.subTopicName,
          clauseNo: initialData?.clauseNo,
          clauseName: initialData?.clauseName,
          keyword: initialData.keyword
        }
      })
    }),
    getQuestionList: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getComplianceAssessmentQuestionListWithPaginationAndSearch/${initialData.page}/${initialData.pageLimit}`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          topicName: initialData.topicName,
          subTopicName: initialData.subTopicName,
          clauseNo: initialData?.clauseNo,
          clauseName: initialData?.clauseName,
          keyword: initialData.keyword
        }
      }),
    }),
    getPolicyStatusDetails: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getPolicyBasedDetails`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          keyword: initialData.keyword
        }
      }),
    }),
    getSubTopicStatusDetails: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getSubTopicBasedDetails`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          topicName: initialData.topicName,
          subTopicName: initialData.subTopicName,
          keyword: initialData.keyword
        }
      }),
    }),
    getClauseList: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getComplianceAssessmentClauseListWithPaginationAndSearch/${initialData?.page}/${initialData?.pageLimit}`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          topicName: initialData.topicName,
          subTopicName: initialData.subTopicName,
          keyword: initialData.keyword
        }
      })
    }),

    getClauseCount: build.mutation({
      query: ({ initialData }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/getComplianceAssessmentClauseListWithPaginationAndSearchForCount`,
        method: "POST",
        body: {
          complianceAssessment: initialData.assessmentId,
          policyName: initialData.policyName,
          topicName: initialData.topicName,
          subTopicName: initialData.subTopicName,
          keyword: initialData.keyword
        }
      })
    }),

    //User Access Review
    getUserAccessList: build.mutation({
      query: ({ pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/UserAccessRest/applicationUserAccessReview/${pageNumber}/${itemsPerPage}`,
        method: "GET",
      }),
    }),
    getUserAccessListCount: build.mutation({
      query: () => ({
        url: `${GNC_BASE_API}/UserAccessRest/countForApplicationUserAccessReview`,
        method: "GET",
      }),
    }),
    getUserAccessPreviousCycleList: build.mutation({
      query: ({ postBody, pageNumber, itemsPerPage }) => ({
        url: `${GNC_BASE_API}/awsIam/getAwsPreviousCycleMainDetailsWithPaginationAndSearch/${pageNumber}/${itemsPerPage}`,
        method: "POST",
        body: postBody
      }),
    }),
    getUserAccessListCountDone: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/awsIam/getAwsPreviousCycleMainDetailsWithSearchCount`,
        method: "POST",
        body: payload
      }),
    }),
    getUserAccessReviewComplianceTrend: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/UserAccessRest/CISOGraphOne`,
        method: "POST",
        body: payload
      }),
    }),
    getUserAccessReviewDue: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/UserAccessRest/CISOGraphTwo`,
        method: "POST",
        body: payload
      }),
    }),
    getEPSSscore: build.mutation({
      query: (cveId) => ({
        url: `${GNC_BASE_API}/trs/getEpssValue/${cveId}`,
        method: "GET",
      }),
    }),

    //Cloud Cost insights
    getCostTrendByResource: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/awsCloudCost/getTopFiveServiceByAccountId`,
        method: "POST",
        body: payload
      }),
    }),
    getCostTrendByRegion: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/awsCloudCost/getTopFiveRegionByAccountId`,
        method: "POST",
        body: payload
      }),
    }),
    saveAttachmentsFromComplianceAssessment: build.mutation({
      query: ({ formData, Id }) => ({
        url: `${GNC_BASE_API}/complianceAssessment/complianceAssessmentSaveQuestionId/${Id}`,
        method: "POST",
        body: formData
      })
    }),
    getCostTrendByAccountId: build.mutation({
      query: (payload) => ({
        url: `${GNC_BASE_API}/awsCloudCost/getCostTrendByAccountId`,
        method: "POST",
        body: payload
      }),
    }),
  }),
});



